import React, { useEffect } from 'react';
import styled from 'styled-components';
import { datadogRum } from '@datadog/browser-rum';

const Wrapper = styled.div`
  background-color: #ff7171;
  border-radius: 3px;
  color: white;
  font-size: 14px;
  max-width: 315px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  text-align: center;
  position: relative;
  margin-bottom: 1rem;
  z-index: 2;

  &::after {
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -10px;
    content: '';
    width: 0;
    height: 0;
    border-top: solid 10px #ff7171;
    border-left: solid 10px transparent;
    border-right: solid 10px transparent;
  }
`;

const getNodeText = (node: React.ReactNode): string => {
  if (node == null) return '';

  switch (typeof node) {
    case 'string':
    case 'number':
      return node.toString();

    case 'boolean':
      return '';

    case 'object': {
      if (node instanceof Array) return node.map(getNodeText).join('');

      if ('props' in node) return getNodeText(node.props.children);
    }

    default:
      return '';
  }
};

const FormError: React.FC<React.ComponentProps<typeof Wrapper>> = ({
  children,
  ...rest
}) => {
  useEffect(() => {
    const text = getNodeText(children);
    datadogRum.addError(new Error(text.toString()), {
      customType: 'formError'
    });
  }, [children]);
  return <Wrapper {...rest}>{children}</Wrapper>;
};

export default FormError;
